// utilities/Fetch/createAsyncFetcher.js
export function createAsyncFetcher(apiCall, dataKey, set, opts) {
  const updater =
    typeof opts === "function" ? opts : (opts && opts.updater) || null;
  const loadingKey =
    typeof opts === "object" && opts?.loadingKey ? opts.loadingKey : "loading";

  return async (...args) => {
    set({ [loadingKey]: true, error: null });
    try {
      const { code, data } = await apiCall(...args);
      if (code === 200) {
        if (updater) {
          set((state) => updater(state, data, args));
        } else {
          set({ [dataKey]: data });
        }
      } else {
        throw new Error(`Error al cargar ${dataKey}`);
      }
    } catch (err) {
      set({ error: err instanceof Error ? err.message : String(err) });
    } finally {
      set({ [loadingKey]: false });
    }
  };
}